import React from 'react';
import { observer } from 'mobx-react';
import { TafCheckboxInput } from '@taf-ui/react';

import {
  Props,
} from 'interfaces/Input';
import AppStorage from '../../Storage/Storage';
import {
  translate,
} from '../../utils/utils';
import Labels from '../../enums/Labels';
import { TafChangeEvent } from '@taf-ui/core';

class InputCheckbox extends React.PureComponent<Props> {
  private readonly storage: AppStorage;

  constructor(props: Props) {
    super(props);
    this.storage = AppStorage.getInstance();
  }

  changeHandler = (e: CustomEvent<TafChangeEvent<boolean>>): void => {
    const {
      input,
      onChangeHandler,
    } = this.props;

    input.onChange(e.detail.value);

    if (onChangeHandler) onChangeHandler(e);
  };

  render(): React.ReactElement {
    const {
      input,
      meta,
      label,
      trustedLabel,
    } = this.props;

    // TODO: trusted label is case when we set markup as label, and need to add this feature in Library

    const lang = this.storage.getLocale;

    const checkboxLabel = trustedLabel ? trustedLabel : translate(label as Labels, lang);

    return (
      <TafCheckboxInput
        value={!!input.checked}
        name={input.name}
        inputId={input.name}
        label={checkboxLabel}
        onTafChange={this.changeHandler}
        validationState={meta.error && meta.touched ? 'error' : undefined}
        validationMessage={translate(meta.error as Labels, lang)}
      />
    );
  }
}

export default observer(InputCheckbox);
